import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe } from '@ngx-translate/core';
import { mVToVolt } from '../../../../../../helper/convertMeasure';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';

@Component({
  selector: 'app-p00030-tair-status',
  templateUrl: './p00030-tair-status.component.html',
  styleUrls: ['./p00030-tair-status.component.scss'],
  imports: [
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    DisplayRubriqueStatusComponent,
  ],
})
export class P00030TairStatusComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  get deviceTableData() {
    return (
      this.productClass?.getProductDeviceTableFromPool(
        this.edroNetworkManager.getPoolContext().pool!,
      ) ?? {}
    );
  }

  hasProductWarning() {
    const master = getPoolMasterClass(
      this.edroNetworkManager.getPoolContext().pool!,
    );
    return (
      master?.hasProduct(
        this.edroNetworkManager.getPoolContext().pool!,
        new P00030(),
      ) ?? 0
    );
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly mVToVolt = mVToVolt;
}
